import React from 'react';
import './ResellersBenefits.scss';

/**
 * Renders the resellers benefits module
 * @param {array} benefits
 * @param {string} heading
 * @param {string} background_color
 * @param {string} text_color
 * @param {boolean} isHubspot
 * @returns {JSX.Element}
 * @constructor
 */
const ResellersBenefits = ({
  benefits,
  heading,
  background_color = 'background-color-green',
  text_color = 'white',
  isHubspot = false,
}) => (
  <div className={`c-resellers-benefits ${background_color}`}>
    {heading && (
      <h2 className={`c-resellers-benefits__heading h2-roobert color-${text_color}`}>{heading}</h2>
    )}
    <div className="c-resellers-benefits__inner">
      {benefits.map((benefit) => (
        <div className="c-resellers-benefits__benefit">
          <div className="c-resellers-benefits__benefit-icon">
            <img src={benefit.icon.url} alt={benefit.icon.alt} />
          </div>
          <div className={`c-resellers-benefits__benefit-title h3-roobert color-${text_color}`}>
            <h3>{benefit.title}</h3>
          </div>
          {!isHubspot ? (
            <div className={`c-resellers-benefits__benefit-description body-1 color-${text_color}`}>
              <p>{benefit.description}</p>
            </div>
          ) : (
            <div
              className={`c-resellers-benefits__benefit-description body-1 color-${text_color}`}
              dangerouslySetInnerHTML={{ __html: benefit.description }}
            ></div>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default ResellersBenefits;
